export const FETCH_BUSINESS_UNIT_REQUEST = "FETCH_BUSINESS_UNIT_REQUEST";
export const FETCH_BUSINESS_UNIT_SUCCESS = "FETCH_BUSINESS_UNIT_SUCCESS";
export const FETCH_BUSINESS_UNIT_FAILURE = "FETCH_BUSINESS_UNIT_FAILURE";

export const UPDATE_BUSINESS_UNIT_REQUEST = "UPDATE_BUSINESS_UNIT_REQUEST";
export const UPDATE_BUSINESS_UNIT_SUCCESS = "UPDATE_BUSINESS_UNIT_SUCCESS";
export const UPDATE_BUSINESS_UNIT_FAILURE = "UPDATE_BUSINESS_UNIT_FAILURE";
export const CREATE_BUSINESS_UNIT_REQUEST = "CREATE_BUSINESS_UNIT_REQUEST";
export const CREATE_BUSINESS_UNIT_SUCCESS = "CREATE_BUSINESS_UNIT_SUCCESS";
export const CREATE_BUSINESS_UNIT_FAILURE = "CREATE_BUSINESS_UNIT_FAILURE";
